var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PAUSED-LEADS-LIST-ITEM-PLACEHOLDER"},[_c('div',{staticClass:"TIME"},[_c('span',{staticClass:"x-pulse PLACEHOLDER"}),_c('span',{staticClass:"x-pulse PLACEHOLDER"})]),_c('div',{staticClass:"d-flex flex-1-1 fd-column p-l-2"},[_c('span',{staticClass:"x-pulse WIDE-PLACEHOLDER"})])])
}]

export { render, staticRenderFns }